import PageBody from "../PageBody";
import Notifications from "../components/pages/notifications/Notifications";

const NotificationsPage = () => {
  return (
    <PageBody>
      <Notifications />
    </PageBody>
  );
};

export default NotificationsPage;
